import { render, staticRenderFns } from "./addOss.vue?vue&type=template&id=0cd0a00f&scoped=true&"
import script from "./addOss.vue?vue&type=script&lang=js&"
export * from "./addOss.vue?vue&type=script&lang=js&"
import style0 from "./addOss.vue?vue&type=style&index=0&id=0cd0a00f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd0a00f",
  null
  
)

export default component.exports